module.exports = __webpack_public_path__ + "img/check.45cc0fd4.svg";